import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { TabSingleComponent } from "src/app/shared/components/ui/tabs/tab-single/tab-single.component";
import { TabsComponent } from "src/app/shared/components/ui/tabs/tabs.component";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { TabIdList } from "src/app/shared/models/tab.model";
import { ui_tabIdList } from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";
import { AuthService } from "src/app/shared/services/auth.service";
import { Router, RouterModule } from "@angular/router";

@Component({
  selector: "kpi-main",
  templateUrl: "./kpi-main.component.html",
  styleUrls: ["./kpi-main.component.scss"],
  imports: [
    TabsComponent,
    TabSingleComponent,
    CommonModule,
    RouterModule,
  ],
  standalone: true,
})
export class KpiMainComponent implements OnInit {
  routeEnum: RouteEnum = new RouteEnum();
  tabIdList: TabIdList;
  urlKpiClinics: string = this.routeEnum.URL_KPI_CLINICS;
  urlKpiBrosh: string = this.routeEnum.URL_KPI_BROSH;
  urlKpiAgents: string = this.routeEnum.URL_KPI_AGENTS;

  showMainTab: boolean = false;
  showAgentsTab: boolean = false;
  showClinicsTab: boolean = false;

  get clinicTabTitle(): string {
    return this.isClinicOwner ? this.authService.currentUser.clinic?.clinicDescr : "translate.kpi.clinics";
  }


  get isClinicOwner(): boolean {
    return this.authService.currentUser.roleCode == "CLINIC_OWNER";
  }


  constructor(
    private readonly store: Store,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.tabIdList = this.store.selectSignal(ui_tabIdList)();
    this.showMainTab = this.authService.currentUser.roleCode == "ADMIN" || this.authService.currentUser.roleCode == "AGENT";
    this.showAgentsTab = this.authService.currentUser.roleCode == "ADMIN";
    this.showClinicsTab = true;
  }


}
